import get from 'lodash/get'
import capitalize from 'lodash/capitalize'

export function getOtherFormsTitle (htmlAst, elementId) {
  const otherCommonFormsNode = htmlAst.children.find((htmlNode) => {
    const id = get(htmlNode, 'properties.id')

    return id && id.startsWith(elementId)
  })

  const children = get(otherCommonFormsNode, 'children')
  const otherCommonFormsTextNode = children
    ? children.find((htmlNode) => get(htmlNode, 'type') === 'text')
    : null

  return get(otherCommonFormsTextNode, 'value')
    ? otherCommonFormsTextNode.value
    : 'Other common posts'
}

export const getRelatedPosts = ({ allPosts, otherPosts }) => {
  // both capture what we want at [1]
  const pathRegex = /.+\/([a-zA-Z-\d]+)\/?$/
  const tagRegex = /^\/[a-zA-Z-\d]+\/([a-zA-Z-\d]+)\/[a-zA-Z-\d]+($|\/$)/

  return allPosts.filter((node) => {
    let isRelatedArticle = false
    otherPosts.forEach((link) => {
      const pathMatch = link.properties.href.match(pathRegex)
      if (pathMatch && pathMatch.length > 0 && pathMatch[1] === node.slug) {
        isRelatedArticle = true
        const tagMatch = link.properties.href.match(tagRegex)
        node.currentTag =
          tagMatch && tagMatch.length > 0 ? slugToTag(tagMatch[1]) : null
      }
    })
    return isRelatedArticle
  })
}

/**
 * returns iterable list of elements with `isMdModify=true` on marked elements
 */
export function markHtmlNode ({
  htmlAst, // remark AST
  markedElementId, // html element id
  markedElementTagName, // html tag name
  markedElementAdditionalPropName = 'isMdModify', // custom html attribute to check for identity
  markedElementTagNames = [], // [html tag names]
}) {
  const mdDataFilter = (htmlNode) =>
    get(htmlNode, 'tagName') === markedElementTagName &&
    get(htmlNode, 'properties.id').startsWith(markedElementId)

  // add prop isMdModify to the relevant htmlNode
  const elements = htmlAst.children.flatMap((htmlNode) => {
    if (mdDataFilter(htmlNode)) {
      return htmlNode
    } else {
      return get(htmlNode, 'children')
    }
  })

  let isMdModify = false
  elements.forEach((element) => {
    const id = get(element, 'properties.id')
    if (id && id.startsWith(markedElementId)) {
      isMdModify = true
    }

    if (element && element.properties) {
      element.properties[markedElementAdditionalPropName] = isMdModify
    }
  })

  return [elements, mdDataFilter]
}

/**
 * //TODO: name this just 'modify', so users can think: `htmlAst.modify`
 */
export function modifyHtmlAst ({
  htmlAst, // remark AST
  // the next 3 parameters specify which element to 'mark' and remove, as well as collect the
  // elements in markedElementTagNames
  modifyElementId, // html element id
  modifyElementTagName, // html tag name
  // TODO: make this optional - if specified, it applies this check. if not, it's only the first element found
  // actually, modifyElementTagName should be the only one 'required'... modifyElementId should also be optional
  modifyElementPropName, // custom html attribute to check for identity
  mdElementTagNames, // [html tag names]
}) {
  const MARKED_PROP_NAME = 'markedForDel'

  const [elements] = markHtmlNode({
    htmlAst, // remark AST
    markedElementId: modifyElementId, // html element id
    markedElementTagName: modifyElementTagName, // html tag name
    markedElementTagNames: mdElementTagNames,
    markedElementAdditionalPropName: MARKED_PROP_NAME,
  })

  // data to modify
  const mdModifyElements = elements.filter(
    (e) =>
      get(e, `properties.${MARKED_PROP_NAME}`) &&
      mdElementTagNames.includes(get(e, 'tagName'))
  )

  const newHtmlAst = { ...htmlAst }

  // logic to remove from htmlAst (need to pass in htmlAst data)
  // e.g. in help template, remove the related articles links
  newHtmlAst.children = htmlAst.children.filter((htmlNode) => {
    let toBeRemoved = false
    const id = get(htmlNode, 'properties.id')
    const children = get(htmlNode, 'children')
    if (children) {
      mdModifyElements.forEach((e) => {
        const tagMatchedChildren = children.filter(
          (child) =>
            get(child, `properties.${MARKED_PROP_NAME}`) &&
            mdElementTagNames.includes(get(child, 'tagName')) &&
            child.children.some(
              (deeperChild) => deeperChild.value === e.children[0].value
            )
        )

        if (
          tagMatchedChildren.some(
            (child) =>
              child.properties[modifyElementPropName] ===
              e.properties[modifyElementPropName]
          )
        ) {
          toBeRemoved = true
        }
      })
    }

    return !(toBeRemoved || (id && id.startsWith(modifyElementId)))
  })

  return [newHtmlAst, mdModifyElements]
}

// helpers
const slugToTag = (slug) => {
  return slug
    ? capitalize(slug.split('-').join(' ')).replace('Pdf', 'PDF')
    : null
}
